import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo192 from '../assets/images/logo192.png';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path: string) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo">
            <img 
              src={logo192} 
              alt="Đức Phát Đạt Logo" 
              style={{ 
                height: '40px', 
                width: 'auto', 
                marginRight: '10px',
                verticalAlign: 'middle'
              }} 
            />
            <span style={{ verticalAlign: 'middle' }}>Đức Phát Đạt</span>
          </Link>
          
          <div className={`nav-menu ${isMenuOpen ? 'mobile-open' : ''}`}>
            <Link to="/" className={isActive('/')}>
              Trang chủ
            </Link>
            <Link to="/about" className={isActive('/about')}>
              Về Đức Phát Đạt
            </Link>
            <Link to="/services" className={isActive('/services')}>
              Dịch vụ
            </Link>
            <Link to="/news" className={isActive('/news')}>
              Tin tức
            </Link>
            <Link to="/contact" className={isActive('/contact')}>
              Liên hệ
            </Link>
          </div>

          <button 
            className="mobile-menu-toggle"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </nav>
      </div>

      <style>{`
        .mobile-menu-toggle {
          display: none;
          flex-direction: column;
          background: none;
          border: none;
          cursor: pointer;
          padding: 0.5rem;
        }

        .mobile-menu-toggle span {
          width: 25px;
          height: 3px;
          background-color: var(--primary-color);
          margin: 2px 0;
          transition: 0.3s;
        }

        .mobile-open {
          display: flex !important;
          flex-direction: column;
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: white;
          box-shadow: var(--shadow);
          padding: 1rem;
        }

        @media (max-width: 768px) {
          .mobile-menu-toggle {
            display: flex;
          }

          .nav-menu {
            display: none;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
